import styled from '@emotion/styled';
import { Button, ComponentTextSmall, HeadingText40, pxToRem } from '@modernhealth/vital-components';
import { colors } from '@modernhealth/vital-foundation';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PathwayProviderFragment } from '../documents/fragments.generated';
import { ProfileCard } from './ProfileCard';

export const ProviderProfileCard: FC<{
    provider: PathwayProviderFragment['provider'];
    onClick: () => void;
}> = ({ provider, onClick }) => {
    const { t } = useTranslation();

    return (
        <StyledContainer>
            <ProfileCard coverImage={provider.avatar ?? ''}>
                <ProviderContent>
                    <div>
                        <ComponentTextSmall fontColor="gray85">
                            {t('pathways:components.pathway_provider_card.your_pathway_provider')}
                        </ComponentTextSmall>
                        <HeadingText40>{`${provider.firstName} ${provider.lastName}`}</HeadingText40>
                    </div>
                    <StyledButton variant="secondary" rounded onClick={onClick}>
                        {t('pathways:components.pathway_provider_card.view_profile')}
                    </StyledButton>
                </ProviderContent>
            </ProfileCard>
        </StyledContainer>
    );
};

const StyledButton = styled(Button)({
    backgroundColor: 'transparent',
});

const ProviderContent = styled.div({
    flex: 1,
    background: `linear-gradient(to bottom right, ${colors.violet10}, ${colors.blue10})`,
    borderRadius: '0 0 8px 8px',
    padding: pxToRem(24, 28),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
});

const StyledContainer = styled.div({
    width: '100%',
    marginTop: pxToRem(28),
    minHeight: '100px',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
});
